// authentication.service.ts
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { CommonService } from "./../common.service";

@Injectable({
  providedIn: "root",
})
export class CalculatePremiumforHealthIciciElevate {
  individual: any = {
    coverAmount: "",
    tenure: "",
  };

  familyData: any = {
    coverAmount: "",
    tenure: "",
  };
 
  constructor(private commonService: CommonService) {}

  generateUUID(): string {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
      /[xy]/g,
      function (c) {
        const r = (Math.random() * 16) | 0;
        const v = c === "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      }
    );
  }

  calculatePremium(storedPayload?: any[]): Observable<any> {
    const RequestId = this.generateUUID();
    const url = "/icici/premium";
    let payload;
    if (storedPayload != undefined) {
      payload = storedPayload;
      localStorage.setItem(
        "icici_elevate_quote_payload",
        JSON.stringify(payload)
      );
    } else {
      payload = this.createPayload(RequestId);
    }

    const body = {
      payload: payload,
    };
    return this.commonService.post(url, body);
  }

  // Payload for all
  private createPayload(RequestId: string): any {
    let insuredMember = [];
    let insuredDetails: any[] = [];
    let coverAmount: string;
    let tenure: number;
    const insuranceType = localStorage.getItem("tab");
    let proposer_data;
    if (insuranceType == "I") {
      proposer_data = JSON.parse(localStorage.getItem("userData1"));
      tenure = this.individual.tenure;
      coverAmount = this.individual.coverAmount;
      insuredMember.push({
        InsuredType: "Adult",
        AddOns: [],
        DateOfBirth: this.formatDOB(proposer_data.dob),
        Gender:
          proposer_data.gender == "0"
            ? "Male"
            : proposer_data.gender === "1"
            ? "Female"
            : "Others",
        InsuredOccupation: "",
        IsPED: false,
        RelationshipWithApplicant: "SELF",
        Name: "",
      });
    } else {
      const totalMember = JSON.parse(localStorage.getItem("userData2Insured"));
      proposer_data = JSON.parse(localStorage.getItem("userData2"));

      totalMember[0].form.forEach((member) => {
        let insuredTypes = "";
        let gender = "Others";
        if (member.relation.toLowerCase() === "self") {
          gender =
            proposer_data.gender === "0"
              ? "Male"
              : proposer_data.gender === "1"
              ? "Female"
              : "Others";
        } else {
          if (
            [
              "father",
              "son",
              "husband",
              "brother",
              "grand-father",
              "father-in-law",
              "son-in-law",
              "uncle",
              "grand-son",
            ].includes(member.relation.toLowerCase())
          ) {
            gender = "Male";
          } else if (
            [
              "mother",
              "daughter",
              "wife",
              "sister",
              "grand-mother",
              "mother-in-law",
              "daughter-in-law",
              "aunt",
              "grand-daughter",
            ].includes(member.relation.toLowerCase())
          ) {
            gender = "Female";
          }
          else if(proposer_data.gender=='0' && ["spouse"].includes(member.relation.toLowerCase())){
             gender = "Female";

          }
            else if(proposer_data.gender=='1' && ["spouse"].includes(member.relation.toLowerCase())){
             gender = "Male";

          }
        }

        if (member.membertype.endsWith("a")) {
          insuredTypes = "Adult";
        } else if (member.membertype.endsWith("c")) {
          insuredTypes = "Kid";
        }

        insuredMember.push({
          InsuredType: insuredTypes,
          AddOns: [],
          DateOfBirth: this.formatDOB(member.DateOfBirth),
          Gender: gender,
          InsuredOccupation: "",
          IsPED: false,
          RelationshipWithApplicant:  member.relation.replace(/-/g, ' ').toUpperCase(),
          Name: member.name || "",
        });
      });

      coverAmount = this.familyData.coverAmount;
      tenure = this.familyData.tenure;
      totalMember[0].form.forEach((member) => {
        insuredDetails.push({
          DateOfBirth: member.DateOfBirth,
          RelationshipWithApplicant: member.relation,
        });
      });
    }

    const icici_quote_payload = {
      Insured: insuredMember,
      RequestId: RequestId,
      SumInsured: proposer_data.coverAmount,
      Tenure: proposer_data.tenure,
      PanNumber: "",
      ProposerName: "",
      PinCode: proposer_data.pincode,
      ProposerDOB: "",
      TwoHourHospitalization: true,
    };
    localStorage.setItem(
      "icici_elevate_quote_payload",
      JSON.stringify(icici_quote_payload)
    );

    return icici_quote_payload;
  }

  private formatDOB(input: string | number | Date) {
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];

    const date = new Date(input);
    const day = String(date.getDate()).padStart(2, "0");
    const month = months[date.getMonth()];
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  }
}
